import React, { Component, Fragment } from 'react';
import './App.css';
import { REACT_APP_MODE, REACT_APP_LIVE_API, REACT_APP_TEST_API, REACT_APP_LOCAL_API } from './appSettings.json';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Container from 'react-bootstrap/Container'
import Stage1New from './components/stage1-new/stage1-new';
import Stage2New from './components/stage2-new/stage2-new';
import Stage3New from './components/stage3-new/stage3-new';
import Thankyou from './components/thankyou/thankyou';
import 'bootstrap/dist/css/bootstrap.min.css';
import store from "./js/store/index";
import { v4 as uuidv4 } from 'uuid';

const _nodeURL = REACT_APP_MODE === 'LIVE' ? REACT_APP_LIVE_API : REACT_APP_MODE === 'LOCAL' ? REACT_APP_LOCAL_API : REACT_APP_TEST_API;
const urlPropsQueryConfig = {
  id: { type: UrlQueryParamTypes.string, queryParam: 'id' },
  //existing: { type: UrlQueryParamTypes.string, queryParam: 'existing' }
};

class App extends Component {

  constructor(props) {
    super(props);
    this.state = { appState: store.getState(), whyDataFetched: false };  

    // if (this.props.id !== undefined) {
    //   this.state.appState.whyPad.id = this.props.id;
    //   this.state.appState.whyPad.newCustomer.existingCustomer = 1;
    // } else {
    //   this.state.appState.whyPad.id = uuidv4();
    //   this.state.appState.whyPad.newCustomer.existingCustomer = 0;
    // }

    this.state.appState.whyPad.id = this.props.id;
    this.state.appState.whyPad.newCustomer.existingCustomer = this.props.existing;

    const unsubscribe = store.subscribe(() => {
      this.setState({ appState: store.getState() });
      console.log(store.getState())
    })
  }

  componentDidMount() {
    if (this.props.existing !== "0") {
      //this.state.appState.whyPad.id = this.props.id;
      fetch(_nodeURL + 'fetchWhyCustomer/' + this.props.id, {
        method: 'GET',
        headers: { 'Content-type': 'application/json' }
      }).then((response) => {
        response.json().then((body) => {
          console.log("Response from fetchWhyCustomer: ", body);
          var x = JSON.parse(body);
          if (x.length > 0) {
            this.state.appState.whyPad.newCustomer = JSON.parse(x[0].json).newCustomer;
            this.state.appState.whyPad.newCustomer.existingCustomer = "1";
          } else {
            this.state.appState.whyPad.newCustomer.existingCustomer = "0";
          }
          
          this.setState({ whyDataFetched: true });
        });
      });
    }
    else {
      this.setState({ whyDataFetched: true });
    }
  }

  render() {
    return (
      <Fragment>
        <Header></Header>
        <Container className="containerStyle" style={{ minHeight: '1150px' }}>
          { this.state.whyDataFetched ? 
            <div>
              { this.state.appState.stageVisibility === 'SHOW_STAGE1' ? <Stage1New></Stage1New> : null }
              { this.state.appState.stageVisibility === 'SHOW_STAGE2' ? <Stage2New></Stage2New> : null }
              { this.state.appState.stageVisibility === 'SHOW_STAGE3' ? <Stage3New></Stage3New> : null }
              { this.state.appState.stageVisibility === 'SHOW_THANKYOU' ? <Thankyou></Thankyou> : null }
            </div>
          : null }
        </Container>
        <Footer></Footer>
      </Fragment>
    );
  }
}

//export default App;
export default addUrlProps({ urlPropsQueryConfig })(App);